import { render } from "./ModiScreen.vue?vue&type=template&id=fe4f36b4&scoped=true&ts=true&lang=pug"
import script from "./ModiScreen.vue?vue&type=script&lang=ts"
export * from "./ModiScreen.vue?vue&type=script&lang=ts"

import "./ModiScreen.vue?vue&type=style&index=0&id=fe4f36b4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe4f36b4"]])

export default __exports__